import React, { useState, useEffect } from "react";
import axios from "axios";
import LiveTradeTable from "./UpdateLiveTradeTable";

const UpdateData = () => {
    const [tradeData, setTradeData] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.get('https://server.anshfintech.com/api/common/live/live-trade'); // Replace with your API endpoint
            setTradeData(response.data);
        } catch (error) {
            console.error("Error fetching live trade data", error);
        }
    }

    return (
        <div className="mt-20 px-4 md:px-4">
            <div className="relative pt-10 pb-2 md:pt-10 md:pb-2 lg:pt-12 lg:pb-8 z-10 text-white">
                <div className="bg-gradient-to-tl h-[90vh] w-[90vw] from-[#FEF35A99]/90 via-[#FFFFFF]/40 to-[#FEF35A99]/10 p-[1px] rounded-[12px] md:rounded-[26px] mb-20">
                    <LiveTradeTable tradeData={tradeData && tradeData} fetchData={fetchData}/>
                </div>
            </div>
        </div>
    );
};

export default UpdateData;
